/* eslint-disable lit-a11y/click-events-have-key-events */
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import dataOffer from './offers.js';
import assetsPath from '../../constant.js';

/**
 * The Footer SOWN molecule contains the brand logo and links to others pages.
 *
 * language - The translation language (ie : fr-FR|en-EN|be-FR|be-EN|fr-BE|en-BE) - Default value : fr-FR.
 * didomiUrl - The Didomi script to launch Cookies modal.
 * baseUrl - The base Url. Used to build Url in the component.
 * assistanceUrl - The assistance Url. Used to build Url in the component.
 * clientUrl - The nem Url. Used to build Url in the component.
 * withWhatsapp - Switch between whatsapp block and default contact block. Boolean. Default : false.
 */
@customElement('nn-footer-oswn')
export class FooterOswn extends LitElement {
  static styles = css`
    .hidden,
    .show-off {
      display: none;
    }
    .custom-flex {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .icon-inline {
      align-items: center;
      background: none;
      border: 0;
      color: var(--nn-footer-oswn_icon-inline_color, #000);
      display: flex;
      border-radius: 0;
      box-shadow: none;
      font-family: 'font-medium';
      font-size: var(--nn-footer-oswn_icon-inline_font-size, 0.875em);
      justify-content: left;
      line-height: 1;
      margin: var(--nn-footer-oswn_icon-inline_margin, 0);
      padding: var(--nn-footer-oswn_icon-inline_padding, 0 0 5px);
      text-align: left;
      text-decoration: none;
      text-transform: none;
      vertical-align: inherit;
      width: 100%;
    }
    .icon-inline--image {
      flex-shrink: 0;
    }
    .icon-inline--text {
      padding: var(--nn-footer-oswn_icon-inline_--text_padding, 0 0 0 8px);
    }
    .icon-inline--text_title {
      font-family: 'font-heavy';
      padding: var(--nn-footer-oswn_icon-inline--text_title_padding, 0 0 3px 0);
    }
    .icon-inline--text_text {
      color: var(--nn-footer-oswn_icon-inline--text_text_color, #595959);
      font-family: 'font-light';
      font-size: var(
        --nn-footer-oswn_icon-inline--text_text_font-size,
        0.929em
      );
    }
    .icon-inline.multiple {
      align-items: start;
    }
    #footer {
      background: var(--nn-footer-oswn_footer_background, #0e0e0e);
      font-family: 'font-light';
      font-size: var(--nn-footer-oswn_footer_font-size, 16px);
      margin: 0;
      padding: 0;
    }
    #footer ul,
    #footer li {
      list-style-type: none;
    }
    #footer * {
      box-sizing: border-box;
    }
    #footer .container {
      margin: 0 auto;
      max-width: 1470px;
      padding: 0 15px;
      width: 100%;
    }
    #footer a,
    #footer a:focus,
    #footer a:active,
    #footer a:visited,
    #footer a:hover {
      text-decoration: none;
    }
    #footer ul {
      margin: 0;
      padding: 0;
    }
    #footer ul li {
      margin: 0;
    }
    #footer .footer-top {
      background: var(--nn-footer-oswn_footer-top_background, #f9f9f9);
    }
    #footer .footer-top .custom-flex {
      align-items: center;
      flex-wrap: var(--nn-footer-oswn_footer-top_custom-flex_flex-wrap, nowrap);
      gap: var(--nn-footer-oswn_footer-top_custom-flex_gap, 8px);
      justify-content: var(
        --nn-footer-oswn_footer-top_custom-flex_justify-content,
        space-evenly
      );
      min-height: var(
        --nn-footer-oswn_footer-top_custom-flex_min-height,
        110px
      );
      padding: var(--nn-footer-oswn_footer-top_custom-flex_padding, 16px 0);
      width: 100%;
    }
    #footer .footer-top .icon-inline {
      font-size: var(--nn-footer-oswn_footer-top_icon-inline_font-size, 1em);
      padding: var(--nn-footer-oswn_footer-top_icon-inline_padding, 0);
    }
    #footer .footer-top .icon-inline--text_title {
      color: var(
        --nn-footer-oswn_footer-top_icon-inline--text_title_color,
        #001018
      );
      font-size: var(
        --nn-footer-oswn_footer-top_icon-inline--text_title_font-size,
        0.75em
      );
      font-weight: 400;
      margin: 0;
      text-transform: uppercase;
    }
    #footer .footer-top .icon-inline--text_text {
      color: var(
        --nn-footer-oswn_footer-top_icon-inline--text_text_color,
        #686868
      );
      font-family: 'font-extra-light', 'font-light';
      font-size: var(
        --nn-footer-oswn_footer-top_icon-inline--text_text_font-size,
        0.75em
      );
      font-weight: 400;
      margin: 0;
    }
    #footer .footer-middle {
      padding: var(--nn-footer-oswn_footer-middle_padding, 24px 0 16px);
    }
    #footer .footer-middle a,
    #footer .footer-middle a:focus,
    #footer .footer-middle a:active,
    #footer .footer-middle a:visited,
    #footer .footer-middle a:hover {
      color: var(--nn-footer-oswn_footer-middle_a_color, #ececec);
      display: inline-block;
      margin: var(--nn-footer-oswn_footer-middle_a_margin, 4px 0);
      padding: var(--nn-footer-oswn_footer-middle_a_padding, 8px 0);
      transition: var(--nn-footer-oswn_footer-middle_a_transition, 0.3s);
    }
    #footer .footer-middle a:hover {
      color: var(--nn-footer-oswn_footer-middle_a--hover_color, #fff);
      text-decoration: underline;
    }
    #footer .footer-middle .custom-flex {
      align-items: stretch;
      gap: 0 24px;
      text-align: left;
    }
    #footer .footer-middle .custom-flex--column {
      flex-basis: auto;
      flex-shrink: 1;
      flex: 2;
      padding: var(
        --nn-footer-oswn_footer-middle_custom-flex--column_padding,
        0
      );
    }
    #footer .footer-middle .custom-flex--column:first-child {
      flex: 1 0;
    }
    #footer .footer-middle .custom-flex--column:last-child {
      flex: 2 0;
    }
    #footer .footer-middle--category {
      align-items: start;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 0 16px;
      justify-content: start;
    }
    #footer .footer-middle--category_item {
      flex-grow: 1;
      flex-shrink: 2;
      padding: var(--nn-footer-oswn_footer-middle--category_item_padding, 0);
    }
    #footer .footer-middle--category_item .anchor,
    #footer .footer-middle--category_item .anchor:active,
    #footer .footer-middle--category_item .anchor:focus,
    #footer .footer-middle--category_item .anchor:visited,
    #footer .footer-middle--category_item .anchor:hover {
      color: var(
        --nn-footer-oswn_footer-middle--category_item_anchor_color,
        #3695ec
      );
    }
    #footer .footer-middle--category_item .anchor:hover {
      color: var(
        --nn-footer-oswn_footer-middle--category_item_anchor--hover_color,
        #fff
      );
    }
    #footer .footer-bottom {
      margin: var(--nn-footer-oswn_footer-bottom_margin, 0);
      padding: var(--nn-footer-oswn_footer-bottom_padding, 0 0 24px);
      width: 100%;
    }
    #footer .footer-bottom--logos {
      justify-content: var(
        --nn-footer-oswn_footer-bottom--logos_justify-content,
        space-between
      );
      padding: var(--nn-footer-oswn_footer-bottom--logos_padding, 16px 0 0);
      position: relative;
    }
    #footer .footer-bottom--logos:after {
      background: var(
        --nn-footer-oswn_footer-bottom--logos--after_background,
        #494949
      );
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: -24px;
    }
    #footer .footer-links {
    }
    #footer .footer-links--items {
      align-items: center;
      display: flex;
      height: auto;
      justify-content: space-between;
      min-height: var(--nn-footer-oswn_footer-links--items_min-height, 60px);
      padding: var(--nn-footer-oswn_footer-links--items_padding, 24px 0);
    }
    #footer .footer-links--items_item .paragraph-03,
    #footer .footer-links--items_item .paragraph-03:active,
    #footer .footer-links--items_item .paragraph-03:focus,
    #footer .footer-links--items_item .paragraph-03:visited,
    #footer .footer-links--items_item .paragraph-03:hover {
      color: var(
        --nn-footer-oswn_footer-links--items_item_paragraph-03_color,
        #d0d0d0
      );
      display: inline-block;
      font-size: var(
        --nn-footer-oswn_footer-links--items_item_paragraph-03_font-size,
        14px
      );
      margin: var(
        --nn-footer-oswn_footer-links--items_item_paragraph-03_margin,
        4px 0
      );
      padding: var(
        --nn-footer-oswn_footer-links--items_item_paragraph-03_padding,
        8px 0
      );
      text-align: center;
    }
    #footer .footer-links--items_item .paragraph-03:hover {
      text-decoration: underline;
    }
    #footer .footer--title {
      color: var(--nn-footer-oswn_footer--title_color, #a8a8a8);
      font-family: 'font-medium';
      font-size: var(--nn-footer-oswn_footer--title_font-size, 20px);
    }
    @media (max-width: 1300px) {
      :host {
        --nn-footer-oswn_footer-top_custom-flex_gap: 24px 8px;
        --nn-footer-oswn_footer-top_custom-flex_padding: 24px 0;
        --nn-footer-oswn_footer-top_custom-flex_flex-wrap: wrap;
      }
      #footer .footer-top .custom-flex {
        height: auto;
      }
      #footer .footer-top .icon-inline {
        margin: 0 auto;
        width: var(--nn-footer-oswn_footer-top_icon-inline_width, fit-content);
      }
    }
    @media (max-width: 991px) {
      #footer .footer-middle .custom-flex--column:first-child,
      #footer .footer-middle .custom-flex--column:last-child {
        flex: 1;
      }
      #footer .footer-links--items {
        flex-direction: column;
      }
    }
    @media (max-width: 991px) and (min-width: 768px) {
      #footer .footer-top .icon-inline {
        margin: 0;
      }
      #footer .footer-top .custom-flex--column {
        width: var(
          --nn-footer-oswn_footer-top_custom-flex--column_width,
          calc(33.33% - 6px)
        );
      }
    }
    @media (max-width: 767px) {
      :host {
        --nn-footer-oswn_footer-top_custom-flex--column_width: calc(50% - 4px);
        --nn-footer-oswn_footer-top_icon-inline_width: 282px;
        --nn-footer-oswn_footer-middle_custom-flex--column_padding: 0;
        --nn-footer-oswn_footer-middle_padding: 32px 0 0;
        --nn-footer-oswn_footer-links--items_padding: 0 0 24px;
        --nn-footer-oswn_footer-bottom_margin: 0 0 24px;
      }
      #footer {
        align-items: center;
        border-top: 1px solid var(--nn-footer-oswn_footer_border-top, #d1d1d1);
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      #footer .footer--title {
        text-align: center;
      }
      #footer .footer-middle .paragraph-02 {
        font-size: var(
          --nn-footer-oswn_footer-middle_paragraph-02_font-size,
          16px
        );
      }
      #footer .footer-middle .custom-flex {
        flex-direction: column;
      }
      #footer .footer-middle .custom-flex--column {
        text-align: center;
      }
      #footer .footer-middle--category_item {
        width: 100%;
      }
    }
    @media (max-width: 600px) {
      :host {
        --nn-footer-oswn_footer-top_custom-flex--column_width: 100%;
      }
    }
    @media (max-width: 479px) {
      :host {
        --nn-footer-oswn_footer-bottom--logos_justify-content: center;
      }
      #footer .footer-bottom--logos {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: var(--nn-footer-oswn_footer-bottom--logos_gap, 16px 32px);
      }
    }
  `;

  @property({ type: String }) baseUrl = 'https://www.nordnet.com/';

  @property({ type: String }) assistanceUrl = '';

  @property({ type: String }) clientUrl = '';

  @property({ type: String }) didomiUrl = '';
  // javascript:Didomi.preferences.show()

  @property({ type: String }) whatsappUrl = '';

  @property({ type: String }) contactUrl = '';

  @property({ type: String }) acceoUrl = '';

  @property({ type: String }) language:
    | 'fr-FR'
    | 'en-EN'
    | 'be-EN'
    | 'be-FR'
    | 'fr-BE'
    | 'en-BE' = 'fr-FR';

  // eslint-disable-next-line class-methods-use-this
  renderTop(
    id: string,
    imageSrc: string,
    alt: string,
    title: string,
    text: string,
    linkTitle: string
  ) {
    if (this.whatsappUrl && id === 'whatsapp') {
      return `
      <div class="custom-flex--column">
        <div class="link">
          <a
            id="footer-${id}"
            class="link"
            href="${this.whatsappUrl}"
            target="_blank"
            rel="nofollow"
            title="${linkTitle}"
          >
            <div class="icon-inline">
              <img
                width="24"
                height="24"
                class="icon-inline--image"
                src="${assetsPath}/icons/${imageSrc}"
                alt="${alt}"
                loading="lazy"
                aria-hidden="true"
              />
              <div class="icon-inline--text">
                <p class="icon-inline--text_title">${title}</p>
                <p class="icon-inline--text_text">${text}</p>
              </div>
            </div>
          </a>
        </div>
      </div>`;
    }
    if (this.contactUrl && id === 'contact') {
      return `
      <div class="custom-flex--column">
        <div class="link">
          <a
            id="footer-${id}"
            class="link"
            href="${this.contactUrl}"
            target="_blank"
            rel="nofollow"
            title="${linkTitle}"
          >
            <div class="icon-inline">
              <img
                width="24"
                height="24"
                class="icon-inline--image"
                src="${assetsPath}/icons/${imageSrc}"
                alt="${alt}"
                loading="lazy"
                aria-hidden="true"
              />
              <div class="icon-inline--text">
                <p class="icon-inline--text_title">${title}</p>
                <p class="icon-inline--text_text">${text}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    `;
    }
    if (this.assistanceUrl && id === 'assistance') {
      return `
      <div class="custom-flex--column">
        <div class="link">
          <a
            id="footer-${id}"
            class="link"
            href="${this.assistanceUrl}"
            target="_blank"
            rel="nofollow"
            title="${linkTitle}"
          >
            <div class="icon-inline">
              <img
                width="24"
                height="24"
                class="icon-inline--image"
                src="${assetsPath}/icons/${imageSrc}"
                alt="${alt}"
                loading="lazy"
                aria-hidden="true"
              />
              <div class="icon-inline--text">
                <p class="icon-inline--text_title">${title}</p>
                <p class="icon-inline--text_text">${text}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    `;
    }
    if (this.acceoUrl && id === 'acceo') {
      return `
      <div class="custom-flex--column">
        <div class="link">
          <a
            id="footer-${id}"
            class="link"
            href="${this.acceoUrl}"
            target="_blank"
            rel="nofollow"
            title="${linkTitle}"
          >
            <div class="icon-inline">
              <img
                width="24"
                height="24"
                class="icon-inline--image"
                src="${assetsPath}/icons/${imageSrc}"
                alt="${alt}"
                loading="lazy"
                aria-hidden="true"
              />
              <div class="icon-inline--text">
                <p class="icon-inline--text_title">${title}</p>
                <p class="icon-inline--text_text">${text}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    `;
    }
    return ``;
  }

  // eslint-disable-next-line class-methods-use-this
  renderMiddleColumn(
    id: string,
    text: string,
    linkUrl: string,
    linkTitle: string
  ) {
    return `
      <li class="footer-middle--category_item">
        <a
          class="paragraph-02"
          id="footer-${id}"
          title="${linkTitle}"
          href="${this.baseUrl}${linkUrl}"
          target="_blank"
          rel="nofollow"
        >
          ${text}
        </a>
      </li>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  renderLogos(
    id: string,
    imageSrc: string,
    alt: string,
    width: string,
    height: string
  ) {
    return `
      <img id="bottom-image-${id}"
        src="${assetsPath}/images/logos/${imageSrc}"
        alt="${alt}"
        width="${width}"
        height="${height}"
      />
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  renderBottom(id: string, text: string, linkUrl: string, linkTitle: string) {
    if (this.didomiUrl && id === 'manage-cookies') {
      return `
        <li class="footer-links--items_item" id="footer-links-${id}">
        <a
          class="paragraph-03"
          id="footer-link-${id}"
          title="${linkTitle}"
          href="${this.didomiUrl}"
        >
          ${text}
        </a>
      </li>
          `;
    }
    if (id === 'launch-alert') {
      return `
      <li class="footer-links--items_item" id="footer-links-${id}">
        <a
          class="paragraph-03"
          id="footer-link-${id}"
          title="${linkTitle}"
          href="${linkUrl}"
          target="_blank"
          rel="nofollow"
        >
          ${text}
        </a>
      </li>
    `;
    }
    if (id !== 'launch-alert' && id !== 'manage-cookies') {
      return `
    <li class="footer-links--items_item" id="footer-links-${id}">
      <a
        class="paragraph-03"
        id="footer-link-${id}"
        title="${linkTitle}"
        href="${this.baseUrl}${linkUrl}"
          target="_blank"
          rel="nofollow"
      >
        ${text}
      </a>
    </li>
  `;
    }
    return ``;
  }

  // eslint-disable-next-line class-methods-use-this
  renderTitle(text: string) {
    return `
      ${text}
    `;
  }

  convertDataToHtml(offerId: string) {
    let contentInString: string = '';
    const targetOffer = (dataOffer[this.language] as any[]).find(
      offer => offer.offer === offerId
    );

    if (offerId === 'FOOTER_TOP') {
      targetOffer.children.forEach((offerChild: any) => {
        contentInString += `${this.renderTop(
          offerChild.id,
          offerChild.imageSrc,
          offerChild.alt,
          offerChild.title,
          offerChild.text,
          offerChild.linkTitle
        )}`;
      });
    } else if (offerId.match(/^FOOTER_MIDDLE_/)) {
      targetOffer.children.forEach((offerChild: any) => {
        contentInString += `${this.renderMiddleColumn(
          offerChild.id,
          offerChild.text,
          offerChild.linkUrl,
          offerChild.linkTitle
        )}`;
      });
    } else if (offerId === 'FOOTER_LOGOS') {
      targetOffer.children.forEach((offerChild: any) => {
        contentInString += `${this.renderLogos(
          offerChild.id,
          offerChild.imageSrc,
          offerChild.alt,
          offerChild.width,
          offerChild.height
        )}`;
      });
    } else if (offerId === 'FOOTER_BOTTOM') {
      targetOffer.children.forEach((offerChild: any) => {
        contentInString += `${this.renderBottom(
          offerChild.id,
          offerChild.text,
          offerChild.linkUrl,
          offerChild.linkTitle
        )}`;
      });
    } else if (offerId.match(/^FOOTER_TITLE_/)) {
      targetOffer.children.forEach((offerChild: any) => {
        contentInString += `${this.renderTitle(offerChild.text)}`;
      });
    }
    return contentInString;
  }

  render() {
    return html`
      <footer id="footer" class="footer">
        ${this.whatsappUrl ||
        this.assistanceUrl ||
        this.contactUrl ||
        this.acceoUrl
          ? html`<div class="footer-top">
              <div class="container">
                <div
                  class="custom-flex"
                  .innerHTML="${this.convertDataToHtml('FOOTER_TOP')}"
                ></div>
              </div>
            </div>`
          : ``}
        <div class="footer-middle">
          <div class="container">
            <div class="custom-flex">
              <div class="custom-flex--column">
                <p
                  class="footer--title"
                  .innerHTML="${this.convertDataToHtml('FOOTER_TITLE_1')}"
                ></p>
                <ul
                  class="footer-middle--category"
                  .innerHTML="${this.convertDataToHtml('FOOTER_MIDDLE_1')}"
                ></ul>
              </div>
              <div class="custom-flex--column">
                <p
                  class="footer--title"
                  .innerHTML="${this.convertDataToHtml('FOOTER_TITLE_2')}"
                ></p>
                <ul
                  class="footer-middle--category"
                  .innerHTML="${this.convertDataToHtml('FOOTER_MIDDLE_2')}"
                ></ul>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="container">
            <div
              class="custom-flex footer-bottom--logos"
              .innerHTML="${this.convertDataToHtml('FOOTER_LOGOS')}"
            ></div>
          </div>
        </div>
        <div class="footer-links">
          <div class="container">
            <ul
              class="footer-links--items"
              .innerHTML="${this.convertDataToHtml('FOOTER_BOTTOM')}"
            ></ul>
          </div>
        </div>
      </footer>
    `;
  }
}
